<ng-container *ngIf="contacts?.length; else tplNoResults">
  <ng-container *ngFor="let contact of contacts">
    <spark-contacts-contact-list-item
      [contact]="contact"
      [user]="findUser(contact.portfolio)"
      [isNavigatable]="isNavigatable"
      (clicked)="onClick($event)">
    </spark-contacts-contact-list-item>
  </ng-container>
</ng-container>

<!-- TODO: add empty status/messaging [future release] -->
<!-- template / no results -->
<ng-template #tplNoResults></ng-template>
